// 실적 관리
export const salesRecordKeys = {
  all: () => ["salesRecord"],
  // [GET] 실적 관리 검색 조건 받아오기 및 권한 데이터 세팅
  searchParam: () => [...salesRecordKeys.all(), "searchParam"],
  // [GET] 회원권 실적 내역 리스트 검색
  mbshpSalesList: (queryData) => [...salesRecordKeys.all(), "mbshp", queryData],
  // [GET] PT 실적 내역 리스트 검색
  ptSalesList: (queryData) => [...salesRecordKeys.all(), "pt", queryData],
  // [GET] 수업 실적 내역 리스트 검색
  classSalesList: (queryData) => [...salesRecordKeys.all(), "class", queryData],
};
